<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第一行(1表) -->
      <tr style="height:100px">
        <td width="30%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="40%" class="titleSpan tableTitle">安 全 评 价 工 作 计 划</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <tr style="height:50px">
        <td width="11%" class="titleSpan">项目名称</td>
        <td colspan="4" class="contentSpan">{{'项目名称'}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0;">
      <tr style="height:50px">
        <td width="11%" :rowspan="100" class="titleSpan">
          <div style="padding:0 15px;">评价组人员任务分工</div>
        </td>
        <td width="11%" class="titleSpan">姓 名</td>
        <td width="15%" class="titleSpan">专 业</td>
        <td width="50%" class="titleSpan">承担的主要工作任务</td>
        <td class="titleSpan">备注</td>
      </tr>
      <tr style="height:50px" v-for="item in 10">
        <td width="11%" class="contentSpan">{{'张三1'}}</td>
        <td width="15%" class="contentSpan">A12228871652X1</td>
        <td width="50%" class="contentSpan">专业</td>
        <td class="contentSpan">工作0001</td>
      </tr>
    </table>
    <table border="1" style="border-top:0;">
      <tr style="height:50px">
        <td width="11%" :rowspan="6" class="titleSpan">
          <div style="padding:0 15px;">评价任务时间安排</div>
        </td>
        <td width="26%" class="titleSpan">工作内容</td>
        <td width="50%" class="titleSpan">时间安排</td>
        <td class="titleSpan">备注</td>
      </tr>
      <tr style="height:50px">
        <td width="26%" class="titleSpan">编制评价方案</td>
        <td width="50%" class="contentSpan">{{'11111'}}</td>
        <td class="contentSpan">{{'11111'}}</td>
      </tr>
      <tr style="height:50px">
        <td width="26%" class="titleSpan">现场勘查、收集资料</td>
        <td class="contentSpan" width="50%">{{'11111'}}</td>
        <td class="contentSpan">{{'11111'}}</td>
      </tr>
      <tr style="height:50px">
        <td width="26%" class="titleSpan">报告编制</td>
        <td class="contentSpan" width="50%">{{'11111'}}</td>
        <td class="contentSpan">{{'11111'}}</td>
      </tr>
      <tr style="height:50px">
        <td width="26%" class="titleSpan">报告内审</td>
        <td class="contentSpan" width="50%">{{'11111'}}</td>
        <td class="contentSpan">{{'11111'}}</td>
      </tr>
      <tr style="height:50px">
        <td width="26%" class="titleSpan">评审版报告修改、编制、定稿</td>
        <td class="contentSpan" width="50%">{{'11111'}}</td>
        <td class="contentSpan">{{'11111'}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>项目组长签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>